<template>
  <div class="home">
    <huehome  class="hp_section"/>
    <works    class="hp_section" id="works" />
    <services class="hp_section" id="services" title="Services__" />
    <client   class="hp_section" id="client"  title="Client__"/>
    <contact  class="hp_section" id="contact" title="Contact__" />
  </div>
</template>

<script>
import huehome from '@/components/huehome.vue';
import client from '@/components/client.vue';
import services from '@/components/services.vue';
import contact from '@/components/contact.vue';
import works from '@/components/works.vue';

export default {
  name: 'home',
  components: {
    huehome,
    client,
    services,
    contact,
    works,
  }
}
</script>
<style lang="scss" scoped>
  .hp_section{
    margin-bottom:50px;
    padding:50px 0;
  }
</style>
